import SectionLabel from '@/pages/home/components/SectionLabel';
import { reactions } from '@/mocks/homeData';

export default function ReactionBoard() {
  return (
    <section id="reactions" className="border-b border-background-200 bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <SectionLabel
          index="04"
          kicker="VOICES · 网友反应"
          title="同一件事，评论区三种不同的看法"
          desc="我们把高赞评论归成几类，同类只留最有代表性的一条，让你看到观点分布，而不是重复刷屏。"
        />

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {reactions.map((reaction) => (
            <div
              key={reaction.tag}
              className="flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <div className="relative h-40 w-full overflow-hidden">
                <img
                  src={reaction.image}
                  alt={`黑料六点 网友反应 配图 ${reaction.tag}`}
                  title="黑料六点档 网友反应"
                  className="h-full w-full object-cover object-top"
                />
                <span className="absolute left-3 top-3 rounded-md bg-accent-500 px-2.5 py-1 text-xs font-medium text-foreground-950">
                  {reaction.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <p className="flex-1 text-sm leading-relaxed text-foreground-800">{reaction.text}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                  <span className="text-xs text-foreground-500">{reaction.author}</span>
                  <span className="flex items-center gap-1 text-xs text-primary-600">
                    <span className="flex h-3.5 w-3.5 items-center justify-center">
                      <i className="ri-heart-3-line" />
                    </span>
                    {reaction.likes}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}